import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMerchantTimezone } from '@/contexts/MerchantTimezoneContext';
import { formatShellClock } from '@lib/datetime';

const MINUTE_MS = 60_000;

/**
 * The top-bar clock (#2476 T3): merchant-timezone weekday, date, time and zone
 * abbreviation. Ticks once a minute, aligned to the minute boundary.
 */
export default function ShellClock({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const { timezone, abbreviation } = useMerchantTimezone();
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const timeout = setTimeout(
      () => {
        setNow(Date.now());
        interval = setInterval(() => setNow(Date.now()), MINUTE_MS);
      },
      MINUTE_MS - (Date.now() % MINUTE_MS),
    );
    return () => {
      clearTimeout(timeout);
      if (interval !== undefined) clearInterval(interval);
    };
  }, []);

  return (
    <span data-testid="shell-clock" className={className}>
      {formatShellClock(new Date(now), timezone, abbreviation, i18n.language, t)}
    </span>
  );
}
